import type { UpdateStateInput } from '@idc-forms/schemas'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import { deleteState, updateState } from '../services/states-admin.service'

export const useUpdateStateMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, payload }: { id: string; payload: UpdateStateInput }) =>
      await updateState(id, payload),
    onSuccess: () => {
      toast.success('Estado actualizado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.states.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}

export const useDeleteStateMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: string) => await deleteState(id),
    onSuccess: () => {
      toast.success('Estado eliminado')
      void queryClient.invalidateQueries({ queryKey: queryKeys.states.all })
      // Los workflows pierden el estado borrado → refrescarlos también.
      void queryClient.invalidateQueries({ queryKey: queryKeys.workflows.all })
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    }
  })
}
